rdefine("app/formular/components/HeadPhone",['app/formular/components/BaseFormEl'],function(BaseFormEl){
    return BaseFormEl.extend({
        bindings:{
            'el':{
                text:'model.base.name'
            }
        },
        initialize:function(){

        }
    });
});